import React from 'react';
import IconContainer from '../IconContainer';

const svg = (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M55.8315 28.6366C55.8315 26.7333 55.6772 24.8197 55.348 22.9473H28.9385V33.7292H44.062C43.4344 37.2066 41.4179 40.2827 38.4652 42.2374V49.2333H47.4879C52.7863 44.3568 55.8315 37.1551 55.8315 28.6366Z" fill="#4285F4"/>
<path d="M28.9396 55.999C36.491 55.999 42.8594 53.5196 47.4993 49.2398L38.4766 42.2439C35.9663 43.9517 32.7256 44.9188 28.9499 44.9188C21.6453 44.9188 15.4519 39.9908 13.2297 33.3652H3.91895V40.5772C8.67204 50.0319 18.3531 55.999 28.9396 55.999Z" fill="#34A853"/>
<path d="M13.2241 33.3677C12.0513 29.8903 12.0513 26.1249 13.2241 22.6475V15.4355H3.92371C-0.0474883 23.3471 -0.0474883 32.6681 3.92371 40.5796L13.2241 33.3677Z" fill="#FBBC04"/>
<path d="M28.9396 11.0822C32.9314 11.0204 36.7894 12.5225 39.6804 15.2797L47.6742 7.28585C42.6125 2.53276 35.8943 -0.0804179 28.9396 0.00188682C18.3531 0.00188682 8.67204 5.96898 3.91895 15.434L13.2194 22.646C15.4313 16.0102 21.635 11.0822 28.9396 11.0822Z" fill="#EA4335"/>
</svg>
);

export default IconContainer(svg);
